'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utilities = require('@brandfolder/utilities');
var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon$1 = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var fontIcon = require('../../icon/font-icon/font-icon.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const baseName = 'pill';
const BasePill = ({ backgroundColor , borderColor , children , className , closeButtonAriaLabel , element: Element = 'button' , ellipsis =true , fontColor , fontSize , isTabbable =true , onClick , onClose , radius , selected , size ='medium' , styleClasses , value , variantName , ...pillProps })=>/*#__PURE__*/ React__default.default.createElement("div", _extends({}, pillProps, {
        className: classnames__default.default(`bf-${baseName}`, `bf-${baseName}__${variantName}`, styleClasses[variantName], styleClasses[size], className, {
            [styleClasses.clickable]: !!onClick,
            [styleClasses.closeable]: !!onClose,
            [styleClasses.selected]: selected,
            [styleClasses.ellipsis]: ellipsis
        }),
        "data-testid": "pill",
        style: {
            ...backgroundColor && {
                background: backgroundColor
            },
            ...borderColor && {
                borderColor
            },
            ...radius && {
                borderRadius: `${radius}px`
            }
        }
    }), /*#__PURE__*/ React__default.default.createElement(Element, {
        className: classnames__default.default([
            styleClasses['pill-content']
        ], `bf-${baseName}__content`, {
            [styleClasses.clickable]: !!onClick
        }),
        onClick: onClick ? (e)=>onClick(value, e) : undefined,
        onKeyUp: onClick ? utilities.keyPressHelper((e)=>onClick(value, e)) : undefined,
        style: fontColor || fontSize ? {
            ...fontColor && {
                color: fontColor
            },
            ...fontSize && {
                fontSize
            }
        } : undefined,
        tabIndex: isTabbable ? undefined : -1,
        type: Element === 'button' ? 'button' : undefined
    }, children), !!onClose && /*#__PURE__*/ React__default.default.createElement("button", {
        "aria-label": closeButtonAriaLabel || `close pill ${children?.toString() || ''}`,
        className: classnames__default.default([
            styleClasses['close-button']
        ], `bf-${baseName}__close-button`),
        "data-testid": "close-pill-button",
        onClick: onClose ? (e)=>onClose(value, e) : undefined,
        onKeyUp: onClose ? utilities.keyPressHelper((e)=>onClose(value, e)) : undefined,
        tabIndex: isTabbable ? undefined : -1,
        type: "button"
    }, /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, {
        "aria-hidden": true,
        className: `bf-${baseName}__close-icon`,
        icon: fontIcon$1.FontIcons.Close
    })));

exports.BasePill = BasePill;
//# sourceMappingURL=base-pill.js.map
